import React, { useMemo, useState } from "react";
import {
  getAccessCodeRequirementChecks,
  getPasswordRequirementChecks,
  PASSWORD_REQUIREMENTS,
  ACCESS_CODE_REQUIREMENTS,
} from "../../../utils/credentialGateUtils";

export const CredentialPasswordField = ({
  id,
  label,
  value,
  onChange,
  maxLength = 20,
  autoComplete = "new-password",
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="mb-3">
      <label className="form-label" htmlFor={id}>
        {label}
      </label>
      <div className="position-relative">
        <input
          id={id}
          type={visible ? "text" : "password"}
          className="form-control pe-5"
          value={value}
          maxLength={maxLength}
          inputMode={maxLength === 6 ? "numeric" : undefined}
          onChange={onChange}
          autoComplete={autoComplete}
          required
        />
        <button
          type="button"
          className="btn btn-link credential-password-toggle"
          onClick={() => setVisible((prev) => !prev)}
          tabIndex={-1}
          aria-label={visible ? "Hide value" : "Show value"}
        >
          <i className={`fas ${visible ? "fa-eye-slash" : "fa-eye"}`} />
        </button>
      </div>
    </div>
  );
};

const RequirementList = ({ title, rules, checks }) => (
  <div className="credential-requirements mb-3">
    <p className="credential-requirements__title mb-2">{title}</p>
    <ul className="credential-requirements__list mb-0">
      {rules.map((rule) => (
        <li key={rule.key} className={checks[rule.key] ? "is-met" : ""}>
          <i
            className={`fas ${checks[rule.key] ? "fa-check-circle" : "fa-circle"} me-2`}
            aria-hidden="true"
          />
          {rule.label}
        </li>
      ))}
    </ul>
  </div>
);

export const CredentialPasswordRequirements = ({ password }) => {
  const checks = useMemo(() => getPasswordRequirementChecks(password), [password]);
  return (
    <RequirementList
      title="Password must include:"
      rules={PASSWORD_REQUIREMENTS}
      checks={checks}
    />
  );
};

export const CredentialAccessCodeRequirements = ({ newAccessCode, confirmAccessCode }) => {
  const checks = useMemo(
    () => getAccessCodeRequirementChecks(newAccessCode, confirmAccessCode),
    [newAccessCode, confirmAccessCode],
  );
  return (
    <RequirementList
      title="Access code must include:"
      rules={ACCESS_CODE_REQUIREMENTS}
      checks={checks}
    />
  );
};

export const CredentialModalTabs = ({
  tab,
  onTabChange,
  showPassword = true,
  showAccessCode = true,
}) => {
  if (!showPassword || !showAccessCode) {
    return null;
  }

  return (
    <div className="credential-modal-tabs mb-3">
      <button
        type="button"
        className={`credential-modal-tab ${tab === "password" ? "active" : ""}`}
        onClick={() => onTabChange("password")}
      >
        Password
      </button>
      <button
        type="button"
        className={`credential-modal-tab ${tab === "accessCode" ? "active" : ""}`}
        onClick={() => onTabChange("accessCode")}
      >
        Access code
      </button>
    </div>
  );
};
